// utils added for iframe/V3 version of codebase
const getQueryStringValue = function (key) {
    return unescape(
        window.location.search.replace(
            new RegExp(
                `^(?:.*[&\\?]${escape(key).replace(/[\.\+\*]/g, '\\$&')}(?:\\=([^&]*))?)?.*$`,
                'i'
            ),
            '$1'
        )
    );
};
export default getQueryStringValue;
